import React from 'react';
import ToolbarCommentButton from './comments/ToolbarCommentButton';
import ToolbarReactionButton from './comments/ToolbarReactionButton';
import { ToolbarButtonGroup } from './ToolbarButton';
import useAppSelector from '../../../../app/redux/useAppSelector';
import useIsPublicView from '../../../../utils/useIsPublicView';
import { useQuill, useQuillReadOnly } from '../../../QuillContext';
import type { Blot } from '../../../types';

interface ToolbarCommentButtonGroupProps {
  blot?: Blot;
  existingComment?: string[] | null;
  onReactionPickerOpenChange?: (open: boolean) => void;
  onCommentButtonClick?: () => void;
}

const ToolbarCommentButtonGroup = ({
  blot,
  existingComment,
  onReactionPickerOpenChange,
  onCommentButtonClick,
}: ToolbarCommentButtonGroupProps) => {
  const isPublicView = useIsPublicView();
  const isEditable = useAppSelector((state) => state.editor.editable);
  const { quill } = useQuill();
  const readOnly = useQuillReadOnly();

  if (
    (isPublicView && (readOnly || !isEditable)) ||
    !quill?.scroll.query('comment')
  ) {
    return null;
  }

  return (
    <ToolbarButtonGroup>
      <ToolbarReactionButton
        blot={blot}
        onPickerOpenChange={onReactionPickerOpenChange}
      />
      <ToolbarCommentButton
        blot={blot}
        existingComment={existingComment}
        onClick={onCommentButtonClick}
      />
    </ToolbarButtonGroup>
  );
};

export default ToolbarCommentButtonGroup;
